import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Switch } from './Switch';

import './Checkbox.scss';
import './Switch.scss';

const Checkbox = ({
  asSwitch, checked, name, onChange, disabled,
}) => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    // update parent state on mount
    onChange({ [name]: isChecked });
  }, []);

  const handleChange = (e) => {
    if (disabled) return;
    const newChecked = e.target.checked;
    setIsChecked(newChecked);
    onChange({ [name]: newChecked });
  };

  const className = (asSwitch) ? 'Checkbox--switch' : 'Checkbox';

  return (
    <div className={className}>
      <input
        id={name}
        name={name}
        type="checkbox"
        className="Checkbox__Input"
        checked={isChecked}
        disabled={disabled}
        onChange={handleChange}
      />
      {
        (asSwitch)
          ? <Switch on={isChecked} name={name} />
          : <div className="Checkbox__Stylized" />
      }

    </div>
  );
};

Checkbox.propTypes = {
  asSwitch: PropTypes.bool,
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  asSwitch: false,
  checked: false,
  disabled: false,
  onChange: () => {},
};

Checkbox.displayName = 'Checkbox';
export default Checkbox;
